import React, { useEffect, useState } from 'react';
import { Slider } from '@/components/ui/slider';

const STORAGE_KEY = 'fontScale';
const BASE_PX = 16;
const DEFAULT_SCALE = 100;

export const getSavedFontScale = () => {
  const saved = parseInt(localStorage.getItem(STORAGE_KEY) || '', 10);
  return Number.isFinite(saved) ? Math.min(140, Math.max(80, saved)) : DEFAULT_SCALE;
};

export const applyFontScale = (scale) => {
  document.documentElement.style.fontSize = `${(BASE_PX * scale) / 100}px`;
};

export const FontSizeSlider = () => {
  const [scale, setScale] = useState(getSavedFontScale);

  useEffect(() => {
    applyFontScale(scale);
    localStorage.setItem(STORAGE_KEY, String(scale));
  }, [scale]);

  return (
    <div className="px-4 pt-3 pb-1" data-testid="font-size-control">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setScale((s) => Math.max(80, s - 5))}
          className="text-xs text-slate-500 hover:text-teal-600 transition-colors leading-none"
          title="Perkecil font"
          data-testid="font-size-decrease"
        >
          A
        </button>
        <Slider
          value={[scale]}
          min={80}
          max={140}
          step={5}
          onValueChange={(v) => setScale(v[0])}
          className="flex-1"
          data-testid="font-size-slider"
          aria-label="Ukuran font"
        />
        <button
          type="button"
          onClick={() => setScale((s) => Math.min(140, s + 5))}
          className="text-lg font-semibold text-slate-500 hover:text-teal-600 transition-colors leading-none"
          title="Perbesar font"
          data-testid="font-size-increase"
        >
          A
        </button>
      </div>
      <button
        type="button"
        onClick={() => setScale(DEFAULT_SCALE)}
        className="mt-1 w-full text-center text-[10px] text-slate-400 hover:text-teal-600 transition-colors"
        title="Kembalikan ukuran normal"
        data-testid="font-size-reset"
      >
        Ukuran font {scale}% {scale !== DEFAULT_SCALE && '· reset'}
      </button>
    </div>
  );
};
